import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import { Router} from '@angular/router';
import * as firebase from 'firebase';
import {ToastService} from '../typescripts/pro/alerts'


@Component({
  selector: 'app-admincentro-escolar-informacion',
  templateUrl: './admincentro-escolar-informacion.component.html',
  styleUrls: ['./admincentro-escolar-informacion.component.scss']
})

export class AdmincentroescolarInformacionComponent implements OnInit{

  centroescolar = [];
  datosdisponibles: boolean = false;
  user;
  userId = '';
  ampa;
  state;
  id;

  mostrarformulario = false;
  mostrarbotonanadircentroescolar = false;
  mostrarselectorimagen = false;

  nombre;
  direccion;
  direccionform
  telefono;
  lat;
  lng;
  url;
  email;
  codigo_postal;
  poblacion;
  provincia;
  tipo;
  descripcion;
  imagen;
  date_registered;

  optionsSelectTipo: Array<any>;
  public map: any = { lat: 39.944204, lng: 0.091394 };

  constructor(
    private router: Router,
    //private route: ActivatedRoute,
    private _location: Location,
    private toast: ToastService ) {
    console.log('constructor')
    this.optionsSelectTipo = [
            { value: 'publico', label: 'Público' },
            { value: 'privado', label: 'Privado' },
            { value: 'concertado', label: 'Concertado' },
        ];

        //obtener datos del usuario admin logueado
        this.userId = localStorage.getItem('userId');
        console.log('UserId', this.userId);
        if(!this.userId){
          this.router.navigate[('')]
        } else {
          firebase.firestore().collection('admins').doc(this.userId)
          .get()
          .then((doc)=>{
            this.user = doc.data();
            console.log('User', this.user)
            console.log('User ampa centro-escolar-informacion', this.user.ampa)
            this.obtenerCentroEscolarInformacion();
          })
        }
  }

   ngOnInit() {}

  // nos traemos los centroescolarinformacion del ampa utilizando el id de ampa
  //que tiene el usuario en su documento
  obtenerCentroEscolarInformacion(){
    console.log('obtenerCentroEscolarInformacion')

    firebase.firestore().collection('centros_escolares')
    .where('ampa','==', this.user.ampa)
    .get()
    .then(snapshot => {
      if (snapshot.size >0){
        this.mostrarbotonanadircentroescolar = false;
        this.mostrarformulario = true;
        firebase.firestore().collection('centros_escolares')
        .where('ampa','==', this.user.ampa)
        .get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                var elemento = doc.data();
                console.log('centroescolarinformacion: ',doc.data())
                if (elemento == undefined)
                        this.state = 'crear'
                else {
                  this.state = 'ver';
                  this.id = doc.id;
                  this.nombre= elemento.nombre || '';
                  this.direccion= elemento.direccion || '';
                  this.direccionform= elemento.direccionform || '';
                  this.telefono= elemento.telefono || '';
                  this.lat= elemento.lat || '';
                  this.lng= elemento.lng || '';
                  this.url= elemento.url || '';
                  this.email= elemento.email || '';
                  this.codigo_postal= elemento.codigo_postal || '';
                  this.poblacion= elemento.poblacion || '';
                  this.provincia= elemento.provincia || '';
                  this.tipo= elemento.tipo || '';
                  this.descripcion= elemento.descripcion || '';
                  this.imagen= elemento.imagen || 'https://firebasestorage.googleapis.com/v0/b/miampa-1be3e.appspot.com/o/compartido%2Fcolegio-foto.jpg?alt=media&token=545ebfe0-ffbe-46a3-bf9b-e85ea4256358';;
                  this.date_registered= elemento.date_registered || '';
                  this.centroescolar = [...this.centroescolar, elemento];
                  console.log('doc.id:', this.id)
                }
            });
        })
        .catch(err => {
            console.log('Error getting documents', err);
        });
      }
      else{
        this.mostrarbotonanadircentroescolar = true;
        this.mostrarformulario = false;
      }
    })
    .catch(err => {
        console.log('Error obteniendo informacion centro escolar', err);
    });

    this.datosdisponibles = true;
  }


  // eliminar centroescolarinformacion id
  eliminar(){
        firebase.firestore().collection('centros_escolares').doc(this.id)
        .delete()
        .then(()=>{
          console.log('Borrado ceip ' + this.id)
          this.showSuccess('Datos eliminados correctamente.');
          this.centroescolar = [];
          this.obtenerCentroEscolarInformacion();
          //this.router.navigate(['/admin/centro-escolar-informacion']);
        })
        .catch(error => {
          console.log(error);
          this.showError('Error al eliminar los datos.');
        })
  }


  // actualizamos los datos de algunos campos del CEIP con this.id
  editar(){
    this.state = 'editar';
    console.log('editar centro escolar ampa:',this.user.ampa)
    console.log('editar centro escolar id:',this.id)
    this.router.navigate(['/admin/centro-escolar-informacion/editar/' + this.id])
  }

  CentroEscolarTipoSeleccionado(event){
    if (event){
      this.tipo = event.target.value || '';
      console.log('this.tipo', this.tipo);
    }
  }

  // volver a la url anterior
  volver(){
    this._location.back();
  }

  //metodos de toast para el usuario
  showSuccess(mensaje) {
    //let options = { closeButton: true, tapToDismiss: false,  titleClass: 'yellow' };
    //this.toast.success(mensaje, 'Toastr success!', options);
    this.toast.success(mensaje);
  }

  showError(mensaje) {
    //let options = { enableHtml: false,  positionClass: 'toast-bottom-right' };
    //this.toast.error(mensaje, 'Toastr error!', options);
    this.toast.error(mensaje);
  }

  showInfo(mensaje) {
    //let options = { extendedTimeOut: 30000, messageClass: 'pink' };
    //this.toast.info('Info message', 'Toastr info!', options);
    this.toast.info(mensaje);
  }

  showWarning(mensaje) {
    //let options = { progressBar: true,  timeOut: 3000,  toastClass: 'black'};
    //this.toast.warning('Warnig message', 'Toastr warning!', options);
    this.toast.warning(mensaje);
  }
}



// WEBPACK FOOTER //
// ./src/app/admincentro-escolar-informacion/admincentro-escolar-informacion.component.ts